import axios from "axios";
import { ChimeSDKMediaPipelinesClient, CreateMediaConcatenationPipelineCommand, DeleteMediaCapturePipelineCommand } from "@aws-sdk/client-chime-sdk-media-pipelines";
import { CLASSROOM_S3_PATH } from "../../utils/constants";
import { getDecryptedDataWithSecretKey } from "../../utils/helper";


export const chaimeStopRecording = async (MediaPipelineId: string, MeetingId: string, MediaPipelineArn: string) => {
    try {

        console.log("[Log] Stop the meeting recording.", { MeetingId, MediaPipelineId, MediaPipelineArn });

        const backendUrl = process.env.REACT_APP_BACKEND_URL;

        if (!backendUrl) {
            throw new Error("Backend URL is not defined in environment variables");
        }

        const query = `
        query getRoleKeysInfo($type: String!) {
            getRoleKeysInfo(type: $type) {
                accessKeyId
                secretAccessKey
                sessionToken
                SourceArn
                SinkType
                SinkArn
                region
                sinkArnDestination
            }
        }
        `;

        // Fetch role keys and meeting configuration from the backend
        const responses = await axios.post(
            backendUrl,
            {
                query,
                variables: {
                    type: CLASSROOM_S3_PATH
                },
            },
            {
                headers: { "Content-Type": "application/json" },
            }
        );

        const { accessKeyId, secretAccessKey, region, sessionToken, sinkArnDestination } = responses?.data?.data?.getRoleKeysInfo;

         if (!accessKeyId || !secretAccessKey || !sessionToken || !region) {
                    throw new Error("Missing necessary credentials for Chime SDK");
                }
        
        const decryptedAccessKeyId = getDecryptedDataWithSecretKey(accessKeyId).originalText;
        const decryptedSecretAccessKey = getDecryptedDataWithSecretKey(secretAccessKey).originalText;
        const decryptedsessionToken = getDecryptedDataWithSecretKey(sessionToken).originalText;

        console.log("[test stop recording]", { decryptedAccessKeyId, decryptedSecretAccessKey, decryptedsessionToken, region });
        const client: any = new ChimeSDKMediaPipelinesClient({
            region, credentials: {
                accessKeyId: decryptedAccessKeyId,
                secretAccessKey: decryptedSecretAccessKey,
                sessionToken: decryptedsessionToken
            }
        });

        console.log("[test stop recording] client", client);

        const concatenateMedialPipelineConfig = new CreateMediaConcatenationPipelineCommand({
            Sinks: [{
                S3BucketSinkConfiguration: {
                    Destination: `${sinkArnDestination}/${MeetingId}`,
                },
                Type: "S3Bucket",
            }],
            Sources: [{
                MediaCapturePipelineSourceConfiguration: {
                    ChimeSdkMeetingConfiguration: {
                        ArtifactsConfiguration: {
                            Audio: {
                                State: "Enabled"
                            },
                            Video: {
                                State: "Enabled"
                            },
                            CompositedVideo: {
                                State: "Enabled"
                            },
                            TranscriptionMessages: {
                                State: "Enabled"
                            },
                            Content: {
                                State: "Enabled"
                            },
                            DataChannel: {
                                State: "Enabled"
                            },
                            MeetingEvents: {
                                State: "Enabled"
                            },
                        },
                    },
                    MediaPipelineArn, // Fixed access to `MediaPipelineArn`
                },
                Type: "MediaCapturePipeline"
            }],
        });
        console.log("[test stop recording] concatenateMedialPipelineConfig", concatenateMedialPipelineConfig);
        
        const concatenateResp = await client.send(concatenateMedialPipelineConfig);

        console.log("Media Concatenate Pipeline Created:", concatenateResp);
        const input: any = {
            MediaPipelineId,
        };

        const command = new DeleteMediaCapturePipelineCommand(input);
        const response = await client.send(command);
        return response;
    } catch (err: any) {
        console.error("[Log] Failed to stop the recording.", err);
    }
}
